import { NavLink, Route, Routes } from 'react-router-dom';
import InformationPage from './pages/InformationPage';
import HistoryPage from './pages/HistoryPage';
import VisionPage from './pages/VisionPage';
import AreaPage from './pages/AreaPage';
import ClientPage from './pages/ClientPage';
import DownloadPage from './pages/DownloadPage';
import './Manage.css';

const ManageApp = () => (
  <div className="manage-layout">
    <nav className="nav">
      <h1>ACE IT Admin</h1>
      <NavLink to="/manage" end>회사정보</NavLink>
      <NavLink to="/manage/visions">비전</NavLink>
      <NavLink to="/manage/histories">연혁</NavLink>
      <NavLink to="/manage/areas">사업영역</NavLink>
      <NavLink to="/manage/clients">고객사</NavLink>
      <NavLink to="/manage/downloads">다운로드</NavLink>
    </nav>
    <main className="main">
      <Routes>
        <Route index element={<InformationPage />} />
        <Route path="visions" element={<VisionPage />} />
        <Route path="histories" element={<HistoryPage />} />
        <Route path="areas" element={<AreaPage />} />
        <Route path="clients" element={<ClientPage />} />
        <Route path="downloads" element={<DownloadPage />} />
      </Routes>
    </main>
  </div>
);

export default ManageApp;
